export function minutesToTime(minutes: number | string): string {
  const intMinutes = parseInt(minutes.toString(), 10)
  if (Number.isNaN(intMinutes)) {
    return '0:00'
  }
  const sign = intMinutes < 0 ? '-' : ''
  const [hh, mm] = separateTime(Math.abs(intMinutes))
  return `${sign}${hh}:${mm.toString().padStart(2, '0')}`
}

export function separateTime(timeInMinutes: number): [number, number] {
  const absoluteMinutes = Math.abs(timeInMinutes) || 0
  const minutes = absoluteMinutes % 60
  const hours = Math.floor(absoluteMinutes / 60)
  return [hours, Math.abs(minutes)]
}
